import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer,
    Button,
    Card,
    CardContent,
    CircularProgress
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import FilterListIcon from "@material-ui/icons/FilterList";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { DownloadOutlined } from '@ant-design/icons';
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { setDSOData } from "../../redux/actions/leadSourceActions";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    headerCell: {
        background: "#1e3a8a",
        color: "#fff",
        fontWeight: 700,
        textAlign: "center",
        border: "1px solid #d6d6d6",
        padding: "10px 12px",
        whiteSpace: "nowrap"
    },
    monthCell: {
        background: "#1e3a8a",
        color: "#fff",
        fontWeight: 700,
        textAlign: "center",
        border: "1px solid #d6d6d6",
        width: "180px", // reduced width
        minWidth: "180px",
        maxWidth: "180px",
        position: "sticky",
        left: 0,
        zIndex: 8
    },
    bodyCell: {
        textAlign: "center",
        border: "1px solid #e0e0e0",
        padding: "8px 10px",
        background: "#fff",
        color: "#1C375D",
        fontWeight: 500
    },
    row: {
        "&:nth-of-type(even)": {
            backgroundColor: "#fafafa"
        },
        "&:hover": {
            backgroundColor: "#eef2ff"
        }
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const DesignSignOffReview = (props) => {
    const classes = useStyles();
    const dsoData = useSelector((state) => state.leadSource.dsoData);
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("designSignOffReview")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [designSignOffTableCsvData, setDesignSignOffTableCsvData] = useState([]);
    const designSignOffTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [designSignOffTableCsvData2, setDesignSignOffTableCsvData2] = useState([]);
    const designSignOffTableCsvButtonRef2 = useRef(null);
    const [triggerDownload2, setTriggerDownload2] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState("")
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']


    const [lastUsedParams, setLastUsedParams] = useState(null);
    const [isInitialRender, setIsInitialRender] = useState(true);
    const THIRTEENTH_BUTTON_DISABLE_UNTIL_KEY = 'thirteenthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        expCenters();
        locations();
        fetchUsersData();
        if ((userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser))) {
            designSignOffReview()
            setSelectedRole(ROLENAME.DesignUser)
        } else {
            designSignOffReview()
            setSelectedRole("ALL")
        }
    }, []);

    // Trigger CSV download for the values table once data is ready
    useEffect(() => {
        if (triggerDownload && designSignOffTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (designSignOffTableCsvButtonRef.current?.link) {
                    designSignOffTableCsvButtonRef.current.link.click();
                    setTriggerDownload(false);
                }
            }, 200);

            return () => clearTimeout(timer);
        }
    }, [triggerDownload, designSignOffTableCsvData]);

    // Trigger CSV download for the count table once data is ready
    useEffect(() => {
        if (triggerDownload2 && designSignOffTableCsvData2.length > 0) {
            const timer = setTimeout(() => {
                if (designSignOffTableCsvButtonRef2.current?.link) {
                    designSignOffTableCsvButtonRef2.current.link.click();
                    setTriggerDownload2(false);
                }
            }, 200);

            return () => clearTimeout(timer);
        }
    }, [triggerDownload2, designSignOffTableCsvData2]);
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "designUser", label: "Design User" },
        { key: "designAssistantManager", label: "Design Assistant Manager" },
        { key: "designManager", label: "Design Manager" },
        { key: "designDGM", label: "Design DGM" },
        { key: "designStage", label: "Design Stage" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "internalDesignSignOffDate", label: "Internal Design Sign-Off Date" },
        { key: "designSignOffDate", label: "Customer Design Sign-Off Approval Date" },
        { key: "movedToImosCustomerApprovalD2E", label: "Customer Design Sign-Off For Incentive" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "HoldRevocationDate", label: "Revocation Date" },
        { key: "currentStage", label: "Current Stage" },
        { key: "department", label: "Department" }

    ];

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "value", label: "Value (INR)" },
        { key: "city", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "internalDesignSignOffDate", label: "Internal Design Sign-Off Date" },
        { key: "customerDesignSignOffDate", label: "Customer Design Sign-Off Approval Date" },
        { key: "customerDesignSignOffForIncentive", label: "Customer Design Sign-Off For Incentive" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "tokenPercent", label: "Token % Received" },
    ];

    const generateTableCsv = () => {
        try {
            let csvArray = [];
            if (popMonthData && popMonthData.length > 0) {
                popMonthData.forEach((data, i) => {
                    const value = ((data?.staticDesignWonAmount || data?.staticSalesWonAmount) / 1.18) / 100000;
                    let obj = {
                        serialNo: i + 1,
                        projectCode: data?.erpProjectNo || "NA",
                        leadNumber: data?.lead_no || "NA",
                        clientName: data?.customerId?.name || "N/A",
                        value: value ? value.toFixed(2) : "N/A",
                        city: data?.experienceCenterId?.locationId?.name || "N/A",
                        expCtrName: data?.experienceCenterId?.name || "N/A",
                        salesWonDate: data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "-",
                        internalDesignSignOffDate: data?.internalDesignSignOffDate ? moment(data?.internalDesignSignOffDate).format("DD-MM-YYYY") : "-",
                        customerDesignSignOffDate: data?.customerDesignSignOffDate ? moment(data?.customerDesignSignOffDate).format("DD-MM-YYYY") : "-",
                        customerDesignSignOffForIncentive: data?.movedToImosCustomerApprovalD2E ? moment(data?.movedToImosCustomerApprovalD2E).format("DD-MM-YYYY") : "-",
                        materialDeliveryDate: data?.materialDispatchedDate ? moment(data?.materialDispatchedDate).format("DD-MM-YYYY") : "-",
                        actualCompletionDate: data?.executionCompletionDate ? moment(data?.executionCompletionDate).format("DD-MM-YYYY") : "-",
                        tokenPercent: data?.tokenPercent !== null ? data?.tokenPercent : "null",
                    };
                    csvArray.push(obj);
                });
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            }, 100);
        } catch (error) {
            console.error("Error generating table CSV:", error);
            props?.setSnackInfo("Error generating table CSV", "error");
        }
    };

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerId?.name,
                    totalValue:
                        ((popMonthData[i]?.staticDesignWonAmount / 1.18) / 100000).toFixed(2),
                    location: popMonthData[i]?.experienceCenterId?.locationId?.name,
                    expCtrName: popMonthData[i]?.experienceCenterId?.name,
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    salesUser: popMonthData[i]?.salesUser ? popMonthData[i]?.salesUser?.name : 'NA',
                    salesManager: popMonthData[i]?.salesManager ? popMonthData[i]?.salesManager?.name : 'NA',
                    salesDGM: popMonthData[i]?.salesDGM ? popMonthData[i]?.salesDGM?.name : 'NA',
                    salesAssistantManager: popMonthData[i]?.salesAssistantManager ? popMonthData[i]?.salesAssistantManager?.name : 'NA',

                    designUser: popMonthData[i]?.designUser ? popMonthData[i]?.designUser?.name : 'NA',
                    designManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    designAssistantManager: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : 'NA',
                    currentStage: popMonthData[i]?.currentStage ? popMonthData[i]?.currentStage : 'NA',
                    department: popMonthData[i]?.departmentId?.name ? popMonthData[i]?.departmentId?.name : 'NA',
                    designStage: popMonthData[i]?.stage ? popMonthData[i]?.stage : "NA",


                    internalDesignSignOffDate: popMonthData[i]?.internalDesignSignOffDate
                        ? moment(popMonthData[i]?.internalDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: popMonthData[i]?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    movedToImosCustomerApprovalD2E: popMonthData[i]?.movedToImosCustomerApprovalD2E
                        ? moment(popMonthData[i]?.movedToImosCustomerApprovalD2E).format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: popMonthData[i]?.materialDispatchedDate
                        ? moment(popMonthData[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: popMonthData[i]?.executionCompletionDate
                        ? moment(popMonthData[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    HoldRevocationDate: popMonthData[i]?.proposedDesignStartDate
                        ? moment(popMonthData[i]?.proposedDesignStartDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    reasonDesignHold: popMonthData[i]?.designHoldSelectedTypes ? popMonthData[i]?.designHoldSelectedTypes : '-',
                    probableRestartingDate: popMonthData[i].proposedDesignStartDate ?
                        moment(popMonthData[i]?.proposedDesignStartDate).format('DD-MM-YYY') : "-",
                    probableDesignSignOffDate: popMonthData[i].probableDesignSignOffDate ?
                        moment(popMonthData[i].probableDesignSignOffDate).format('DD-MM-YYY') : "-",
                    adm: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : "-",
                    operationDM: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : "-",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     internalDesignSignOffDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                //     HoldRevocationDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const isEqual = (obj1, obj2) => {
        // First check if both objects have the same keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        // Check if all keys in obj2 exist in obj1
        for (const key of keys2) {
            if (!keys1.includes(key)) {
                return false;
            }
        }

        // Then compare each key's value
        for (const key in obj1) {
            if (Array.isArray(obj1[key])) {
                // For arrays, check if they have the same length and same items
                if (!Array.isArray(obj2[key]) || obj1[key].length !== obj2[key].length) {
                    return false;
                }

                // For arrays of objects with _id, compare by _id
                if (obj1[key].length > 0 && obj1[key][0]?._id) {
                    const obj1Ids = new Set(obj1[key].map(item => item._id));
                    const obj2Ids = new Set(obj2[key].map(item => item._id));

                    // Check if sets are equal
                    if (obj1Ids.size !== obj2Ids.size) {
                        return false;
                    }

                    for (const id of obj1Ids) {
                        if (!obj2Ids.has(id)) {
                            return false;
                        }
                    }
                } else {
                    // Simple comparison for primitive arrays
                    for (let i = 0; i < obj1[key].length; i++) {
                        if (obj1[key][i] !== obj2[key][i]) {
                            return false;
                        }
                    }
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const designSignOffReview = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let currentObj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            // selectedRole: usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL"),
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            lost: selectLost !== "" ? selectLost : "",
            pivotValue: 'designSignOffReview',
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            currentObj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            currentObj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        // try {
        //     let response = await HttpService.getSalesDataBasedOnExpCenter(currentObj);
        //     setStore(response.data);
        // } catch (error) {
        //     props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        // }
        let shouldMakeApiCall = false;

        // Case 1: No dsoData - must call API
        if (!dsoData || dsoData === null) {
            shouldMakeApiCall = true;
        }
        // Case 2: Not initial render AND parameters changed
        else if (!isInitialRender && lastUsedParams && !isEqual(lastUsedParams, currentObj)) {
            shouldMakeApiCall = true;
        }

        setLoading(true);
        try {
            if (shouldMakeApiCall) {
                // Call API with current parameters
                let response = await HttpService.getSalesDataBasedOnExpCenter(currentObj);
                setStore(response.data);
                dispatch(setDSOData(response.data));
            } else {
                // Use existing data
                setStore(dsoData);
            }

            // Always save the current parameters
            setLastUsedParams({ ...currentObj });

            // No longer initial render after first execution
            if (isInitialRender) {
                setIsInitialRender(false);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
        }
        setLoading(false);
    }

    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(THIRTEENTH_BUTTON_DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(THIRTEENTH_BUTTON_DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(THIRTEENTH_BUTTON_DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    // Format time for display
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(THIRTEENTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds

        // Run the original functionality
        setIsSpinning(true);
        getRefreshedData(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput);
        setTimeout(() => {
            setIsSpinning(false);
        }, 1000);
    };

    const getRefreshedData = async (addLocation, addExpCenter, usersData, selectedSearchType, searchInput) => {
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            // selectedRole: usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL"),
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            lost: selectLost !== "" ? selectLost : "",
            pivotValue: 'designSignOffReview',
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        setLoading(true);
        try {
            let response = await HttpService.getSalesDataBasedOnExpCenter(obj);
            setStore(response.data);
            dispatch(setDSOData(response.data));
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        setLoading(false);
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        designSignOffReview(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        designSignOffReview(selectedLocation, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            tokenPercentage: event.target.value !== "" ? event.target.value : "",
            lost: selectLost !== "" ? selectLost : "",
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput !== "" ? searchInput.toUpperCase() : ""
        }
        props.setLoading(true);
        try {
            let users = ''
            if (selectedUsers && selectedUsers.length !== 0) {
                users = selectedUsers?.map((el) => el._id)
            }
            obj.users = users ? users : ""
            obj.selectedRole = ""
            obj.pivotValue = pivot
            let response = await HttpService.getSalesDataBasedOnExpCenter(obj);
            setStore(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        props.setLoading(false);
    }

    const handleSelectDepartment = (event) => {
        setSelectedDepartment(event.target.value)
    }

    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        obj.pivotValue = pivot
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            if (!role) {
                designSignOffReview(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
            }
            setUsersData(response.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const fetchUsersData = async () => {
        let obj = {
            role: ROLENAME.DesignUser
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error, "error")
        }
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }
    const handleExpData = async (newvalue) => {
        setLoading(true);
        await designSignOffReview(selectedLocation, newvalue, selectedUsers, selectedSearchType, searchInput)
        setLoading(false);
    }


    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newValue) => {
        setLoading(true);
        await designSignOffReview(newValue, selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput)
        setLoading(false);
    }

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
        handleUsersData(newvalue)
    }

    const handleUsersData = async (newvalue) => {
        setLoading(true);
        let obj = {
            users: newvalue,
            role: selectedRole
        }
        await designSignOffReview(selectedLocation, selectedExperienceCenter, obj, selectedSearchType, searchInput)
        setLoading(false);
    }

    const getDataBasedOnClickDesignSignOff = async (e, month, innerEl, val) => {
        let obj = {}
        let users = ''
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        let locationData =
            selectedLocation && selectedLocation.length > 0
                ? selectedLocation.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        if (val === 'designSignOffReview') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                selectedLocation: innerEl.locationId ? innerEl.locationId : locationData,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                lost: selectLost !== "" ? selectLost : "",
                pivotValue: 'designSignOffReview',
                userExpCenter: userDetails.experienceCenterId,
                userLocation: userDetails.selectedLocation,
                users: users ? users : "",
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : "",
                dateInfo: storeDateFilter
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'designSignOffReview',
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    dateInfo: storeDateFilter
                }
            } else {
                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endMonth: month[month.length - 1].monthNumber, endYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenter,
                    selectedLocation: locationData,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'designSignOffReview',
                    userExpCenter: userDetails.experienceCenterId,
                    userLocation: userDetails.selectedLocation,
                    users: users ? users : "",
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : "",
                    dateInfo: storeDateFilter
                }
            }
        }
        if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.DesignUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            let response = await HttpService.getDataBasedClickSales(obj);
            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        designSignOffReview(selectedLocation, selectedExperienceCenter, selectedUsers, "", "")
    }

    // Function to generate CSV data for design sign off values table
    const generateDesignSignOffValuesTableCsvData = () => {
        try {
            if (!store || store.length === 0 || !store[0]?.monthlyGrandTotal) {
                return [];
            }

            const localExpCenterData = {};
            store.forEach((el) => {
                if (!localExpCenterData[el.experienceCenterName]) {
                    localExpCenterData[el.experienceCenterName] = [];
                }
                localExpCenterData[el.experienceCenterName].push(el);
            });

            const localUniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));

            if (localUniqueexperienceCenterNames.length === 0) {
                return [];
            }

            const csvRows = [];

            // Get header order from store (matching table header structure)
            const headerExpCenters = store.slice(0, uniqueexperienceCenterCode.length - 1);

            // Per-month rows - match exact table calculation
            store[0].monthlyGrandTotal.forEach((month) => {
                const row = {};
                row["Internal Design Sign-Off Month"] = `${month.monthName.slice(0, 3)}-${month.year % 100}`;

                // Use same order as table headers
                headerExpCenters.forEach((expCenter) => {
                    const experienceCenterName = expCenter.experienceCenterName;
                    // Sum all innerEl values for this experience center and month (matching table display)
                    let total = 0;
                    localExpCenterData[experienceCenterName]?.forEach((innerEl) => {
                        const monthData = innerEl.monthlyGrandTotal?.find(
                            (entry) => entry.monthName === month.monthName && entry.year === month.year
                        );
                        total += monthData?.totalGrandTotal || 0;
                    });
                    row[expCenter.expCenterCode] = total;
                });

                // Monthly grand total column - sum all experience center values for this month
                // Calculate by summing all values already in the row
                const rowGrandTotal = Object.keys(row)
                    .filter(key => key !== "Internal Design Sign-Off Month")
                    .reduce((sum, key) => sum + (parseFloat(row[key]) || 0), 0);
                row["Grand Total"] = rowGrandTotal;
                csvRows.push(row);
            });

            // Grand Total row - match exact table calculation
            const grandTotalRow = {};
            grandTotalRow["Internal Design Sign-Off Month"] = "Grand Total";
            // Use same order as table headers
            headerExpCenters.forEach((expCenter) => {
                const experienceCenterName = expCenter.experienceCenterName;
                // Match table calculation: store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.grandTotal : 0), 0)
                const total = store.reduce((sum, el) => {
                    return sum + (el.experienceCenterName === experienceCenterName ? (el.grandTotal || 0) : 0);
                }, 0);
                grandTotalRow[expCenter.expCenterCode] = total;
            });
            // Overall Grand Total - sum of all monthly Grand Totals (sum of Grand Total column values)
            const overallGrandTotal = csvRows.reduce((sum, row) => {
                return sum + (parseFloat(row["Grand Total"]) || 0);
            }, 0);
            grandTotalRow["Grand Total"] = overallGrandTotal;
            csvRows.push(grandTotalRow);

            return csvRows;
        } catch (error) {
            console.error("Error generating design sign off values CSV:", error);
            return [];
        }
    };




    return (
        <div className="App">
            <br />
            <div>
                <Card
                    style={{
                        borderRadius: "12px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        marginBottom: "16px"
                    }}
                >
                    <CardContent style={{ padding: "16px 20px" }}>

                        {/* HEADER */}
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            style={{ marginBottom: "12px" }}
                        >
                            <Grid
                                item
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                }}
                            >
                                <FilterListIcon style={{ color: "#1C375D", fontSize: "20px" }} />

                                <h2
                                    style={{
                                        margin: 0,
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        color: "#1C375D"
                                    }}
                                >
                                    Filters
                                </h2>
                            </Grid>
                        </Grid>

                        <Paper className={classes.paper} elevation={0} style={{ padding: "10px 0" }}>
                            <Grid
                                container
                                spacing={2}
                                justifyContent={
                                    userDetails?.roles && userDetails.roles.some(role =>
                                        [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.AGM_Design, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                                    )
                                        ? "flex-start"
                                        : "center"
                                }
                                alignItems="center"
                            >
                                {userDetails?.roles &&
                                    userDetails.roles.some(role =>
                                        [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.AGM_Design, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                                    ) && (
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedLocation}
                                                    onChange={handleMultipleLocationData}
                                                    options={commonLocation}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Location"
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}
                                {userDetails?.roles &&
                                    userDetails.roles.some(role =>
                                        [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.AGM_Design, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.OperationDesignManager, ROLENAME.AssistantDesignManager, ROLENAME.DesignUser].includes(role.name)
                                    ) && (
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%', marginTop: '0.4rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedExperienceCenter}
                                                    onChange={handleMultipleExpData}
                                                    options={commonExpCenter}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Exp-Center"
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        id="startDate"
                                        name="startDate"
                                        label="Internal DSO Start Date"
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        value={storeDateFilter.startDate}
                                        onChange={storePivotDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        id="endDate"
                                        name="endDate"
                                        label="Internal DSO End Date"
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        value={storeDateFilter.endDate}
                                        onChange={storePivotDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        onClick={handlePivotDateFilter}
                                        style={{
                                            backgroundColor: "#F47E46",
                                            color: "#fff",
                                            height: "40px",
                                            borderRadius: "6px",
                                            textTransform: "none",
                                            fontWeight: 500
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="50 % Payment"
                                            variant="outlined"
                                            size="small"
                                            value={selectedValue}
                                            onChange={(e) => handleSelectChange(e)}
                                        >
                                            <MenuItem value="2">All</MenuItem>
                                            <MenuItem value="1">YES</MenuItem>
                                            <MenuItem value="0">NO</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>

                                {/* {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Department"
                                            variant="outlined"
                                            value={selectedDepartment}
                                            onChange={(e) => handleSelectDepartment(e)}
                                        >
                                            <MenuItem value="Sales">Sales</MenuItem>
                                            <MenuItem value="Design">Design</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>
                            </>
                        )} */}

                                {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.DesignHead, ROLENAME.DGM_Design, ROLENAME.AGM_Design, ROLENAME.Admin, ROLENAME.DataAnalyst, ROLENAME.DGM_Sales].includes(role.name))) && (
                                    <>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                                <TextField
                                                    select
                                                    labelId="project-doc"
                                                    label="Select Role"
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedRole}
                                                    onChange={(e) => handleSelectRoles(e)}
                                                // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                                >
                                                    <MenuItem value={"ALL"}>ALL</MenuItem>
                                                    {/* <MenuItem value={ROLENAME.DGM_Design}>DGM</MenuItem> */}
                                                    <MenuItem value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>
                                                    {/* <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem> */}
                                                    <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                </TextField>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedUsers}
                                                    onChange={(e, v) => handleMultipleUsers(e, v)}
                                                    options={usersData}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" size="small" />}
                                                // disabled={pivot === "lost" && !selectedDepartment}  // Disable if selectedDepartment is not set and pivot is "lost"
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}

                                {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.SalesManager, ROLENAME.OperationDesignManager].includes(role.name))) && (
                                    <>
                                        <Grid item xs={12} sm={2}>
                                            <FormControl style={{ width: '80%', marginTop: "0.4rem" }}>
                                                <TextField
                                                    select
                                                    labelId="project-doc"
                                                    label="Select Role"
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedRole}
                                                    onChange={(e) => handleSelectRoles(e)}
                                                >
                                                    <MenuItem value={ROLENAME.OperationDesignManager}>Operation Design Manager</MenuItem>
                                                    {/* <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem> */}
                                                    <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                </TextField>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    value={selectedUsers}
                                                    onChange={(e, v) => handleMultipleUsers(e, v)}
                                                    options={usersData}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" size="small" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}

                                {(userDetails?.roles && userDetails.roles.some(role => [ROLENAME.AssistantSalesManager, ROLENAME.AssistantDesignManager].includes(role.name))) && (
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                                                <TextField
                                                    select
                                                    labelId="project-doc"
                                                    label="Select Role"
                                                    variant="outlined"
                                                    size="small"
                                                    value={selectedRole}
                                                    onChange={(e) => handleSelectRoles(e)}
                                                >
                                                    <MenuItem value={ROLENAME.AssistantDesignManager}>Assistant Design Manager</MenuItem>
                                                    <MenuItem value={ROLENAME.DesignUser}>Designer</MenuItem>
                                                </TextField>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                                <Autocomplete
                                                    multiple
                                                    size="medium"
                                                    value={selectedUsers}
                                                    onChange={(e, v) => handleMultipleUsers(e, v)}
                                                    ListboxProps={{ style: { maxHeight: "15rem" }, position: "bottom-start" }}
                                                    options={usersData}
                                                    getOptionLabel={(option) => option.name}
                                                    renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" size="small" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}
                            </Grid>

                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                                {/* Search Type Dropdown */}
                                <TextField
                                    select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedSearchType}
                                    label="Search Type"
                                    name="searchType"
                                    onChange={(e) => handleSearchType(e.target.value)}
                                    variant="outlined"
                                    style={{ width: '30%', marginRight: '2%' }}
                                    size="small"
                                >
                                    {searchTypes && searchTypes?.map((el, index) => (
                                        <MenuItem key={index} value={el}>{el}</MenuItem>
                                    ))}
                                </TextField>

                                {/* Search Input */}
                                <TextField
                                    label="Enter the input"
                                    name="searched"
                                    size="small"
                                    value={searchInput}
                                    onChange={(e) => { setSearchInput(e.target.value) }}
                                    onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                                    variant="outlined"
                                    style={{ width: '80%' }}
                                />

                                {/* Search Button */}
                                <Button
                                    disabled={!selectedSearchType || !searchInput}
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    style={{ alignSelf: "center", marginLeft: 20 }}
                                    className={classes.leadSearchButton}
                                    onClick={() => handleSearch(searchInput.toUpperCase())}
                                >
                                    Search
                                </Button>

                                {/* Clear Filter Button */}
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    style={{ marginLeft: 10 }}
                                    className={classes.leadClearButton}
                                    onClick={clearDateFilter}
                                >
                                    Clear Filter
                                </Button>
                            </div>
                        </Paper>
                    </CardContent>
                </Card>
            </div>
            <br />
            <div style={{ marginTop: '30px' }}>
                <Paper
                    elevation={4}
                    style={{
                        padding: "20px",
                        borderRadius: "12px",
                        transition: "0.3s ease",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)"}
                    onMouseLeave={(e) => e.currentTarget.style.boxShadow = ""}
                >

                    {/* HEADER CARD */}
                    <Card
                        style={{
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            marginBottom: "16px"
                        }}
                    >
                        <CardContent style={{ padding: "16px 20px" }}>
                            <Grid container alignItems="center" justifyContent="space-between">

                                {/* LEFT */}
                                <Grid item style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <AssessmentIcon style={{ color: "#1C375D" }} />
                                    <h2 style={{ margin: 0, fontWeight: 600, fontSize: "18px" }}>
                                        Design Sign-Off Review
                                    </h2>
                                </Grid>

                                {/* RIGHT */}
                                <Grid item style={{ display: "flex", gap: "10px" }}>

                                    <Button
                                        onClick={handleRefreshClick}
                                        variant="contained"
                                        startIcon={<RefreshIcon />}
                                        disabled={isDisabled}
                                        style={{
                                            backgroundColor: isDisabled ? "#ccc" : "#F47E46",
                                            color: "#fff",
                                            height: "36px",
                                            textTransform: "none"
                                        }}
                                    >
                                        {isDisabled ? `Wait (${formatTimeLeft()})` : "Fetch New Data"}
                                    </Button>

                                    <CSVLink
                                        data={designSignOffTableCsvData}
                                        filename={`Design_Sign_Off_Review_Values_${moment().format(
                                            "YYYY-MM-DD"
                                        )}.csv`}
                                        ref={designSignOffTableCsvButtonRef}
                                        style={{ display: "none" }}
                                    />

                                    <Button
                                        variant="contained"
                                        startIcon={<DownloadOutlined />}
                                        style={{
                                            backgroundColor: "#355025",
                                            color: "#fff",
                                            height: "36px",
                                            textTransform: "none"
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            const csvData = generateDesignSignOffValuesTableCsvData();

                                            if (csvData.length > 0) {
                                                setDesignSignOffTableCsvData(csvData);
                                                setTimeout(() => setTriggerDownload(true), 100);
                                            } else {
                                                props?.setSnackInfo("No data available to export", "warning");
                                            }
                                        }}
                                    >
                                        Download CSV
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        {loading ? (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "300px",
                                flexDirection: "column",
                                gap: "10px"
                            }}>
                                <CircularProgress />
                                <span>Loading data...</span>
                            </div>
                        ) : (
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '10px' }}>
                                <Table
                                    style={{
                                        minWidth: "600px",
                                        tableLayout: "fixed",
                                        borderCollapse: "collapse"
                                    }}
                                >
                                    <TableHead className={classes.headerCell} style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                        <TableRow>
                                            <TableCell
                                                className={classes.headerCell}
                                                style={{
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 11,
                                                    background: "#1f3c88",
                                                    minWidth: "230px",
                                                    width: "230px",
                                                    whiteSpace: "nowrap",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Internal Design Sign-Off Month
                                            </TableCell>
                                            {store?.slice(0, uniqueexperienceCenterCode.length - 1)?.map((experienceCenterName, index) => (
                                                <TableCell
                                                    className={classes.headerCell}
                                                    key={index}
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        letterSpacing: "0.5px",
                                                        textAlign: "center",
                                                        minWidth: "130px",
                                                        width: "100px",
                                                    }}
                                                >
                                                    {experienceCenterName?.expCenterCode}
                                                </TableCell>

                                            ))}

                                            <TableCell
                                                className={classes.headerCell}
                                                style={{
                                                    textAlign: "center",
                                                    minWidth: "130px",
                                                    width: "130px",
                                                }}
                                            >
                                                Grand Total
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                            <TableRow key={monthIndex}>
                                                <TableCell className={classes.monthCell}>
                                                    {/* {month.monthName} {month.year} */}
                                                    {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                                </TableCell>

                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <TableCell
                                                                className={classes.bodyCell}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    color: "blue",
                                                                    textDecoration: "underline",
                                                                    background: "white",
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickDesignSignOff(e, month, innerEl, 'designSignOffReview')}
                                                            >
                                                                {
                                                                    formatNumberToTwoDecimalPlaces(
                                                                        innerEl.monthlyGrandTotal.find(
                                                                            (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                        )?.totalGrandTotal || 0
                                                                    )
                                                                }
                                                            </TableCell>
                                                        ))}
                                                    </>
                                                ))}
                                            </TableRow>
                                        ))}

                                        <TableRow>
                                            <TableCell className={classes.headerCell} style={{ position: 'sticky', left: 0, zIndex: 9 }}>Grand Total</TableCell>
                                            {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                                <TableCell className={classes.headerCell} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClickDesignSignOff(e, store[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                    {
                                                        formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.grandTotal : 0), 0))
                                                    }
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </div>


                    <Card
                        style={{
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            marginTop: "25px"
                        }}
                    >
                        <CardContent style={{ padding: "16px 20px" }}>
                            <Grid container alignItems="center" justifyContent="space-between">

                                {/* LEFT */}
                                <Grid item style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <AssessmentIcon style={{ color: "#1C375D" }} />
                                    <h2 style={{ margin: 0, fontWeight: 600, fontSize: "18px" }}>
                                        Design Sign-Off Review
                                    </h2>
                                </Grid>

                                {/* RIGHT */}
                                <Grid item style={{ display: "flex", gap: "10px" }}>
                                    <CSVLink
                                        data={designSignOffTableCsvData2}
                                        filename={`Design_Sign_Off_Review_Count_${moment().format('YYYY-MM-DD')}.csv`}
                                        ref={designSignOffTableCsvButtonRef2}
                                        style={{ textDecoration: 'none', display: 'none' }}
                                    />
                                    <Button
                                        variant="contained"
                                        startIcon={<DownloadOutlined />}
                                        style={{
                                            backgroundColor: "#355025",
                                            color: "#fff",
                                            height: "36px",
                                            textTransform: "none"
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            // Generate CSV data synchronously for count table
                                            const csvData = (() => {
                                                try {
                                                    if (!store || store.length === 0 || !store[0]?.monthlyGrandTotal) {
                                                        return [];
                                                    }

                                                    const localExpCenterData = {};
                                                    store.forEach((el) => {
                                                        if (!localExpCenterData[el.experienceCenterName]) {
                                                            localExpCenterData[el.experienceCenterName] = [];
                                                        }
                                                        localExpCenterData[el.experienceCenterName].push(el);
                                                    });

                                                    const localUniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));

                                                    if (localUniqueexperienceCenterNames.length === 0) {
                                                        return [];
                                                    }

                                                    const csvRows = [];

                                                    // Get header order from store (matching table header structure)
                                                    const headerExpCenters2 = store.slice(0, uniqueexperienceCenterCode.length - 1);

                                                    // Per-month rows - match exact table calculation
                                                    store[0].monthlyGrandTotal.forEach((month) => {
                                                        const row = {};
                                                        row["Internal Design Sign-Off Month"] = `${month.monthName.slice(0, 3)}-${month.year % 100}`;

                                                        // Use same order as table headers
                                                        headerExpCenters2.forEach((expCenter) => {
                                                            const experienceCenterName = expCenter.experienceCenterName;
                                                            // Sum all innerEl values for this experience center and month (matching table display)
                                                            let total = 0;
                                                            localExpCenterData[experienceCenterName]?.forEach((innerEl) => {
                                                                const monthData = innerEl.monthlyGrandTotal?.find(
                                                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                );
                                                                total += monthData?.count || 0;
                                                            });
                                                            row[expCenter.expCenterCode] = total;
                                                        });

                                                        // Monthly grand total column - sum all experience center values for this month
                                                        // Calculate by summing all values already in the row
                                                        const rowGrandTotal2 = Object.keys(row)
                                                            .filter(key => key !== "Internal Design Sign-Off Month")
                                                            .reduce((sum, key) => sum + (parseFloat(row[key]) || 0), 0);
                                                        row["Grand Total"] = rowGrandTotal2;
                                                        csvRows.push(row);
                                                    });

                                                    // Grand Total row - match exact table calculation
                                                    const grandTotalRow = {};
                                                    grandTotalRow["Internal Design Sign-Off Month"] = "Grand Total";
                                                    // Use same order as table headers
                                                    headerExpCenters2.forEach((expCenter) => {
                                                        const experienceCenterName = expCenter.experienceCenterName;
                                                        // Match table calculation: store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.count : 0), 0)
                                                        const total = store.reduce((sum, el) => {
                                                            return sum + (el.experienceCenterName === experienceCenterName ? (el.count || 0) : 0);
                                                        }, 0);
                                                        grandTotalRow[expCenter.expCenterCode] = total;
                                                    });
                                                    // Overall Grand Total - sum of all monthly Grand Totals (sum of Grand Total column values)
                                                    const overallGrandTotal = csvRows.reduce((sum, row) => {
                                                        return sum + (parseFloat(row["Grand Total"]) || 0);
                                                    }, 0);
                                                    grandTotalRow["Grand Total"] = overallGrandTotal;
                                                    csvRows.push(grandTotalRow);

                                                    return csvRows;
                                                } catch (error) {
                                                    console.error("Error generating design sign off count CSV:", error);
                                                    return [];
                                                }
                                            })();

                                            if (csvData.length > 0) {
                                                setDesignSignOffTableCsvData2(csvData);
                                                setTimeout(() => setTriggerDownload2(true), 100);
                                            } else {
                                                props?.setSnackInfo("No data available to export", "warning");
                                            }
                                        }}
                                    >
                                        Download CSV
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        {loading ? (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "300px",
                                flexDirection: "column",
                                gap: "10px"
                            }}>
                                <CircularProgress />
                                <span>Loading data...</span>
                            </div>
                        ) : (
                            <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                                <Table
                                    style={{
                                        minWidth: "600px",
                                        tableLayout: "fixed",
                                        borderCollapse: "collapse"
                                    }}
                                >
                                    <TableHead className={classes.headerCell} style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                        <TableRow>
                                            <TableCell
                                                className={classes.headerCell}
                                                style={{
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 11,
                                                    background: "#1f3c88",
                                                    minWidth: "230px",
                                                    width: "230px",
                                                    whiteSpace: "nowrap",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Internal Design Sign-Off Month
                                            </TableCell>                                            {store?.slice(0, uniqueexperienceCenterCode.length - 1)?.map((experienceCenterName, index) => (
                                                <TableCell className={classes.headerCell} key={index}

                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        letterSpacing: "0.5px",
                                                        textAlign: "center",
                                                        minWidth: "130px",
                                                        width: "100px",
                                                    }}
                                                >
                                                    {experienceCenterName.expCenterCode}
                                                </TableCell>
                                            ))}

                                            <TableCell
                                                className={classes.headerCell}
                                                style={{
                                                    textAlign: "center",
                                                    minWidth: "130px",
                                                    width: "130px",
                                                }}
                                            >
                                                Grand Total
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                        {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                            <TableRow key={monthIndex}>
                                                <StyledTableCell className={classes.monthCell} style={{ position: 'sticky', left: 0 }}>
                                                    {/* {month.monthName} {month.year} */}
                                                    {`${month.monthName.slice(0, 3)}-${month.year % 100} `}
                                                </StyledTableCell>
                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <TableCell
                                                                className={classes.bodyCell}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    color: "blue",
                                                                    textDecoration: "underline",
                                                                    background: "white",
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickDesignSignOff(e, month, innerEl, 'designSignOffReview')}
                                                            >
                                                                {
                                                                    formatNumberToTwoDecimalPlaces(
                                                                        innerEl.monthlyGrandTotal.find(
                                                                            (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                        )?.count || 0
                                                                    )
                                                                }
                                                            </TableCell>
                                                        ))}
                                                    </>
                                                ))}
                                            </TableRow>
                                        ))}

                                        <TableRow>
                                            <TableCell className={classes.headerCell} style={{ position: 'sticky', left: 0, zIndex: 9 }}>Grand Total</TableCell>
                                            {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                                <TableCell className={classes.headerCell} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClickDesignSignOff(e, store[0].monthlyGrandTotal, experienceCenterName, 'total')}>
                                                    {
                                                        formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.count : 0), 0))
                                                    }
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </div>
                </Paper>
            </div>

            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />

                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB", marginRight: "10px" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>

                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Internal Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Customer Design Sign-Off Approval Date</StyledTableCell>
                                    <StyledTableCell>Customer Design Sign-Off For Incentive</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                    <StyledTableCell>Token % Received</StyledTableCell>

                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData && popMonthData.map((data, i) => {
                                    return (
                                        <>
                                            <StyledTableRow key={i}>
                                                <StyledTableCell>{i + 1}</StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.erpProjectNo ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.erpProjectNo}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.lead_no}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.customerId?.name}
                                                </StyledTableCell>

                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {(
                                                        ((data?.staticDesignWonAmount || data?.staticSalesWonAmount) / 1.18) / 100000
                                                    )?.toLocaleString("en-IN", {
                                                        maximumFractionDigits: 2,
                                                        style: "currency",
                                                        currency: "INR",
                                                    })}
                                                </StyledTableCell>

                                                <StyledTableCell component="th">
                                                    {data?.experienceCenterId?.locationId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.experienceCenterId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>

                                                <StyledTableCell component="th">
                                                    {data?.internalDesignSignOffDate ? moment(data?.internalDesignSignOffDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.customerDesignSignOffDate ? moment(data?.customerDesignSignOffDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.movedToImosCustomerApprovalD2E ? moment(data?.movedToImosCustomerApprovalD2E).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.materialDispatchedDate ? moment(data?.materialDispatchedDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.executionCompletionDate ? moment(data?.executionCompletionDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {data?.tokenPercent !== null ? data?.tokenPercent : "null"}
                                                </StyledTableCell>
                                            </StyledTableRow>

                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(DesignSignOffReview);